<template>
  <div class="how-page content" id="how-page">
    <HeroImage
      title='How <span class="text-nowrap">JORNAY PM</span> works'
      subtitle="All-day ADHD symptom support <br>from the time you rise."
      :image="heroImg"
      :image__sm="mobileImg"
    >
    </HeroImage>

    <nav
      class="nav__wrapper d-flex justify-content-center flex-column align-items-center"
    >
      <b-nav v-b-scrollspy="100" class="text-center desktop">
        <b-nav-item
          href="#the-capsule"
          @click="scrollToSecion($event, 120)"
          class="m-0"
          >The JORNAY PM capsule</b-nav-item
        >
        <span class="separator"></span>
        <b-nav-item
          href="#how-it-works"
          @click="scrollToSecion($event, 120)"
          class="m-0"
          >How it works in the body</b-nav-item
        >
        <span class="separator"></span>
        <b-nav-item
          href="#dosing"
          @click="scrollToSecion($event, 120)"
          class="m-0"
          >Dosing</b-nav-item
        >
        <span class="separator"></span>
        <b-nav-item
          href="#how-to-take"
          @click="scrollToSecion($event, 120)"
          class="m-0"
          >How to take</b-nav-item
        >
      </b-nav>
      <b-nav v-b-scrollspy="237" class="text-center mobile sticky-nav-container">
        <b-nav-item
          href="#the-capsule"
          @click="scrollToSecion($event, 237)"
          class="m-0"
          >The JORNAY PM capsule</b-nav-item
        >
        <span class="separator"></span>
        <b-nav-item
          href="#how-it-works"
          @click="scrollToSecion($event, 237)"
          class="m-0"
          >How it works in the body</b-nav-item
        >
        <span class="separator"></span>
        <b-nav-item
          href="#dosing"
          @click="scrollToSecion($event, 237)"
          class="m-0"
          >Dosing</b-nav-item
        >
        <span class="separator"></span>
        <b-nav-item
          href="#how-to-take"
          @click="scrollToSecion($event, 237)"
          class="m-0"
          >How to take</b-nav-item
        >
      </b-nav>
      <div class="custom-border w-100"></div>
    </nav>

    <TheCapsule id="the-capsule" />
    <HowWorksInBody id="how-it-works" />
    <OptimalDosing id="dosing" />
    <HowToTake id="how-to-take" />

    <PageNav :menus="navItems" customClass="how-page-nav-items"/>

    <InfoBlockSticky />
    <InfoBlock class="trigger" />
    <Footer />
  </div>
</template>

<script>
import HeroImage from "../components/elements/HeroImage";
import heroImg from "../assets/images/3_25/how/hero@2x.webp";
import mobileImg from "../assets/images/3_25/how/hero_s@2x.webp";
import InfoBlockSticky from "../components/sections/InfoBlockSticky";
import InfoBlock from "../components/sections/InfoBlock";
import Footer from "../components/sections/Footer";
import ogImage from "../assets/images/Jornay_OG_Image.jpg";

import TheCapsule from "../components/sections/TheCapsule.vue";
import HowWorksInBody from "../components/sections/HowWorksInBody.vue";
import OptimalDosing from "../components/sections/OptimalDosing.vue";
import HowToTake from "../components/sections/HowToTake.vue";
import PageNav from "../components/elements/PageNav.vue";

export default {
  name: "How",
  metaInfo() {
    return {
      title: "Learn How JORNAY PM® (methylphenidate HCI) Works",
      link: [
        {
          rel: "canonical",
          href: "https://www.jornaypm.com/how-jornay-pm-works",
        },
      ],
      meta: [
        {
          name: "description",
          content:
            "Learn how JORNAY PM® (methylphenidate HCI) works, including dosing, how to take it and how it works in the body. Please see full Prescribing Information, including Boxed Warning, and Medication Guide",
        },
        {
          property: "og:title",
          content: "Learn How JORNAY PM® (methylphenidate HCI) Works",
        },
        {
          property: "og:description",
          content:
            "Learn how JORNAY PM® (methylphenidate HCI) works, including dosing, how to take it and how it works in the body. Please see full Prescribing Information, including Boxed Warning, and Medication Guide",
        },
        {
          property: "og:image",
          content: ogImage,
        },
        {
          property: 'google-site-verification',
          content: 'ARK4dFoz7A2muCj6LE7Z_Pf2IbIg41HtT0dLwNgni8I'
        }
      ],
      // ,
      // script: [
      //   {
      //     vmid: 'ldjson-schema',
      //     innerHTML: this.faqJson,
      //     type: 'application/ld+json',
      //     body: false
      //   }
      // ],
      // __dangerouslyDisableSanitizersByTagID: {
      //   'ldjson-schema': ['innerHTML']
      // }
    };
  },
  data() {
    return {
      faqJson: "",
      heroImg,
      mobileImg,
      customSelectDefaultValue: "#the-capsule",
      navItems: [
        {
          title: 'How to ask about <br class="d-block d-sm-none"/> JORNAY PM',
          routerLinkName: "Resources",
          ctaText: "START HERE",
        },
        {
          title: "Find out if you can save",
          routerLinkName: "Savings",
          ctaText: "CHECK HERE",
        },
      ],
    };
  },
  components: {
    HeroImage,
    InfoBlock,
    InfoBlockSticky,
    Footer,

    TheCapsule,
    HowWorksInBody,
    OptimalDosing,
    HowToTake,
    PageNav,
  },
  methods: {
    scrollToSecion(evt, offset = 15) {
      let offset2 = window.innerWidth > 900 ? 100 : 237;
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        const elementPosition = el.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset2;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
  },
  async created() {
    const response = await this.$http.get("/seo/ld/ld-script-home.json");
    if (response && response.data) {
      this.faqJson = response.data;
    }
  },
};
</script>
